function stripOpenAttribute(attrs: string): string {
  return attrs
    .replace(/\sopen(?:=(?:"[^"]*"|'[^']*'|[^\s>]+))?\s*/gi, ' ')
    .replace(/\s+/g, ' ')
    .trim();
}

function stripOpenFromTagOpening(html: string, tagName: 'details' | 'dialog'): string {
  const re = new RegExp(`<${tagName}\\b([^>]*)>`, 'gi');
  return html.replace(re, (_, attrs: string) => {
    const cleaned = stripOpenAttribute(attrs);
    return `<${tagName}${cleaned ? ` ${cleaned}` : ''}>`;
  });
}

/**
 * Retire les attributs qui forcent l'ouverture des blocs repliables au chargement
 * (ex. `<details open>`) pour que le document s'affiche replié à l'ouverture du dialogue.
 */
export function u3141NormalizeHistoriqueCadastralHtml(html: string): string {
  let out = html;
  out = stripOpenFromTagOpening(out, 'details');
  out = stripOpenFromTagOpening(out, 'dialog');
  return out;
}
